import { computed } from 'vue';
import { useRoute } from 'vue-router';

export const useRouteTitle = (route) => route?.meta?.title || 'Untitled Page';

export const useCurrentRouteTitle = () => {
  const currentRoute = useRoute();
  return computed(() => useRouteTitle(currentRoute));
};
